// extracted by mini-css-extract-plugin
export default {"root":"EmailForm_root__Ttdyr","form":"EmailForm_form__Ey-+f","after":"EmailForm_after__KdAtN"};